import { raceCourseSchema, raceLaneSchema } from '@oefy/core';
import { z } from 'zod';
import { gameKeySchema, schoolGroupSchema, timestampSchema } from './common';
import { dailyGoalSchema } from './play';

export const startGameSchema = z.object({
  gameKey: gameKeySchema,
  schoolGroup: schoolGroupSchema,
  replaceOpen: z.boolean().default(false),
});
export const gameRunParamsSchema = z.object({ runId: z.uuid() });
export const gameChoiceSchema = z.object({ position: z.int().min(0).max(9), lane: raceLaneSchema });
export const gameRunViewSchema = z.object({
  id: z.uuid(),
  childId: z.uuid(),
  schoolGroup: schoolGroupSchema,
  status: z.enum(['in_progress', 'completed', 'abandoned']),
  course: raceCourseSchema,
  choices: z.array(raceLaneSchema).max(10),
  position: z.int().min(0).max(10),
  value: z.int(),
  bestPossible: z.int(),
  worstPossible: z.int(),
  stars: z.int().min(1).max(3).nullable(),
  completedAt: timestampSchema.nullable(),
  dailyGoal: dailyGoalSchema.extend({ reachedNow: z.boolean() }).nullable(),
});
export const gamesOverviewSchema = z.object({
  schoolGroup: schoolGroupSchema,
  /** The games staff switched on for this group, in catalogue order. */
  available: z.array(gameKeySchema),
  dailyGoal: dailyGoalSchema,
  openRun: z
    .object({ id: z.uuid(), schoolGroup: schoolGroupSchema, position: z.int().min(0).max(9) })
    .nullable(),
  best: z
    .object({ stars: z.int().min(1).max(3), finalValue: z.int(), bestPossible: z.int() })
    .nullable(),
});
export type StartGameInput = z.input<typeof startGameSchema>;
export type StartGameRequest = z.output<typeof startGameSchema>;
export type GameChoice = z.infer<typeof gameChoiceSchema>;
export type GameRunView = z.infer<typeof gameRunViewSchema>;
export type GamesOverview = z.infer<typeof gamesOverviewSchema>;
